import { DayjsDatePicker } from '../DayjsDatePicker'

const { RangePicker } = DayjsDatePicker

export const RangeDatePicker = (props: any) => {
  // return <RangePicker {...props} />
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: 200, justifyItems: 'flex-end' }}>
        {label && <span>{label}:</span>}
      </div>
      <div style={{ width: '100%' }}>
        <RangePicker {...props} />
      </div>
    </div>
  )
}
RangeDatePicker.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
